import React from "react";
import { useSelector } from "react-redux";

import { getUser } from "../../../store/modules/session/selectors";

import { LogoSpinner } from "../LogoSpinner";

import { useSignInFlow } from "../../hooks/useSignInFlow";

export const AuthSplash: React.FC = ({ children }) => {
  const user = useSelector(getUser);

  useSignInFlow();

  return user !== null ? <>{children}</> : <LogoSpinner />;
};
